module.exports = __webpack_public_path__ + "static/media/Easyrewardz-Logo-removebg-preview.e9c2f776.png";